import $ from 'jquery';
import React, {PureComponent} from 'react';
import I18n from 'app/i18n';
import {closeMobileMenu, streamFlagImage} from 'app/utils';
import {streamStore} from 'app/store/global';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

const FIVE_MINUTES = 300000;

export default class Stream extends PureComponent {
    rootElement = React.createRef();

    componentDidMount() {
        this.updateBackgroundImage();
        this.previewInterval = setInterval(() => {
            const timestamp = Date.now();
            this.updateBackgroundImage(timestamp);
        }, FIVE_MINUTES);
    }

    componentWillUnmount() {
        clearInterval(this.previewInterval);
    }

    channelName() {
        return this.props.stream.twitch_channel && this.props.stream.twitch_channel.toLowerCase();
    }

    gameClass = gameName => {
        switch (gameName) {
        case 'CS':
        case 'CS:GO':
            return '-cs';
        case 'Dota 2':
            return '-dota';
        case 'Lol':
        case 'LoL':
            return '-lol';
        default:
            return '';
        }
    };

    updateBackgroundImage(timestamp) {
        const {imageLastUpdate, stream} = this.props;
        const img = new Image();

        img.onload = async() => {
            const root = this.rootElement.current;

            const clearClasses = () => {
                root.classList.forEach(cls => {
                    if (cls.startsWith('media-preview-bg-')) {
                        root.classList.remove(cls);
                    }
                });
            };

            if (root) {
                const {classList} = root;
                const gameClass = this.gameClass(stream.game);

                try {
                    const response = await fetch(img.src);

                    if (response.redirected) {
                        if (!classList.contains(`media-preview-bg${gameClass}`)) {
                            classList.add(`media-preview-bg${gameClass}`);
                        }
                    } else {
                        clearClasses();
                        $(root).css('background-image', `url(${img.src})`);
                    }
                } catch {
                    clearClasses();
                    classList.add('media-preview-bg');
                }
            }
        };
        img.src = `https://static-cdn.jtvnw.net/previews-ttv/live_user_${this.channelName()}-250x140.jpg?${timestamp || imageLastUpdate}`;
    }

    handleDeleteUserStream = e => {
        e.preventDefault();
        e.stopPropagation();
        streamStore.deleteUserStream(this.props.stream.id);
    };

    onClick = event => {
        const {stream} = this.props;
        this.props.onClick(stream);
        closeMobileMenu(event);
    };

    render() {
        const {stream, userStream, mobile, iconSize: iconSizeProp, preview} = this.props;
        const iconSize = iconSizeProp || (mobile ? '20px' : '50px');
        const svg = mobile ? 'play-mobile' : 'play-movie';
        return <a href="#"
            style={{display: preview === 'tournaments' ? null : 'inline-block'}}
            onClick={event => this.onClick(event)}
            className={`${mobile || preview === 'aside' ? '' : 'js-streams-minheight'} media-preview media-preview--${preview}`}
            ref={this.rootElement}
        >
            {userStream && <span className="stream--actions">
                <span
                    onClick={this.handleDeleteUserStream}
                    className="stream--action stream--action-delete"
                    title={I18n.t('user.delete')}
                >
                    <SpriteIcon name="#svg-stream-delete" size={{height: 19, width: 19}}/>
                </span>
            </span>}
            <span title={I18n.t('play_stream')} className={`${mobile ? 'media-preview--play-stream-mobile' : ''}`}>
                <SpriteIcon name={`#svg-${stream.target_blank ? 'play-youtube' : svg}`} size={{height: iconSize, width: iconSize}}/>
            </span>
            <span className="media-preview__name">
                {streamFlagImage(stream.author_flag, true, 'media-preview__name--flag')}
                <span className="media-preview__name-text" title={stream.title}>{stream.title}</span>
            </span>
        </a>;
    }
}
